import { ApiProperty } from "@nestjs/swagger"

export class RmGrnPlantRequest {
    @ApiProperty()
    plantId:number
    @ApiProperty()
    grnId:number
    @ApiProperty()
    subPlantId?:number
}